import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Painting } from '../models/painting.model';
import { environment } from 'src/environments/environment';
import { NewPainting } from '../models/newPainting.model';

@Injectable({
  providedIn: 'root',
})
export class PaintingService {
  constructor(private _client: HttpClient) {}

  getAll(): Observable<Painting[]> {
    return this._client.get<Painting[]>(`${environment.apiUrl}/paintings`);
  }
  getById(id: number): Observable<Painting[]> {
    return this._client.get<Painting[]>(
      `${environment.apiUrl}/paintings/${id}`
    );
  }
  add(painting: NewPainting) {
    return this._client.post(`${environment.apiUrl}/paintings`, painting);
  }
  update(id: number, painting: NewPainting) {
    return this._client.put(`${environment.apiUrl}/paintings/${id}`, painting);
  }
  delete(id: number) {
    return this._client.delete(`${environment.apiUrl}/paintings/${id}`);
  }
}
